var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLimeHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.124 30.023s2.443 1.733 2.662 1.606c4.778-2.577 6.362-4.45-.423-4.846-2.799-.147-2.24 3.24-2.24 3.24zM25.77 13.108s-3.023-2.677-11.132-3.473C8.07 8.965.303 9.26.22 7.405c-.068-1.13 4.594-2.837 4.594-2.837s15.331.348 17.522.957c.567.16 12.806 1.513 12.704 3.059-.11 1.686-2.335 2.965-2.335 2.965l-6.935 1.56zM17.015 17.524s16.006 2.296 14.689 3.56c-1.317 1.266-6.67 2.678-9.14 1.882C15.43 20.764 3.376 20.83 2.803 19.9c-.785-1.271 4.314-3.24 4.314-3.24l9.898.864z",
    fill: "#39B54A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.65 31.628c-6.075-7.423 6.826-4.45 8.19-5.435 1.516-1.07 2.39-1.532 5.755-5 .116-.12.15-.187 0-.1-4.266 2.979-25.433-1.078-24.573 3.487.17.502 10.628 7.048 10.628 7.048zM34.4 16.79s1.147-4.733.56-8.4c.9 5.588-33.652-1.835-34.922 5.956-.348 2.155 2.84 5.937 2.956 5.663 2.307-5.395 25.03.662 31.406-3.22zM.215 7.385C.535 3.142 3.73.297 9.123.17a12.246 12.246 0 0 1 8.402 3.287S21.123.003 26.092.17c4.061.154 7.065 3.494 7.508 4.598 0 0-1.85 3.146-16.334 1.486C5.048 4.89.215 7.392.215 7.385z",
    fill: "#004B4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimeHeart);
export default __webpack_public_path__ + "static/media/lime-heart.27117b0455668b2644468aac491ace3f.svg";
export { ForwardRef as ReactComponent };